import React from 'react'

export default function RightArrowIcon () {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        width='28'
        height='28'
        rx='14'
        fill='white'
      />
      <path
        d='M11.5001 20.4584C11.3401 20.4584 11.18 20.3976 11.0584 20.2751C10.8142 20.0309 10.8142 19.635 11.0584 19.3909L16.45 13.9992L11.0584 8.60757C10.8142 8.36341 10.8142 7.96754 11.0584 7.72338C11.3025 7.47921 11.6984 7.47921 11.9426 7.72338L17.7759 13.5567C18.0201 13.8009 18.0201 14.1967 17.7759 14.4409L11.9426 20.2742C11.8201 20.3976 11.6601 20.4584 11.5001 20.4584Z'
        fill='#191531'
      />
    </svg>
  )
}
